import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons/faDownload";
import { xlsxExport } from "../../../utils/xlsxExport";
import Table from "../../../components/coreUiTable/Table";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import { api } from "./api";
import { useTableData } from "../hooks/useTableData";

export const BlackListIpsModule = () => {
  let {
    loading,
    tableInfo: { data, colHeaders } = {},
    tableInfo,
    setTableInfo,
    filteredData,
    onFilteredItemsChange
  } = useTableData({
    endpoint: api.getList
  });

  const deleteBlackListIps = async () => {
    await api
      .removeBlackListIps()
      .catch((error) => console.log("Error while deleting all black list ips", error));
  };

  const deleteBlackListIp = async (item) => {
    let res = await api
      .removeBlackListIp(item["Address"])
      .catch((error) => console.log("Error while deleting black list ip", error));

    if (res.status === 200) {
      let data = tableInfo.data.filter((_, ind) => ind !== item["#"] - 1);
      setTableInfo({ ...tableInfo, data });
    }
  };

  if (loading) return <LoadingAnimation />;

  return data && data.length > 0 ? (
    <div id="black-list-ips-table">
      <button onClick={deleteBlackListIps} className="delete delete-all">
        Clear Black List IPs
      </button>

      <Table
        table={{ colHeaders, data }}
        title=" "
        showCount
        itemsPerPage={15}
        onFilteredItemsChange={onFilteredItemsChange}
        extraColumns={[{ key: "action", label: "Action" }]}
        scopedSlots={{
          action: (item, index) => (
            <td onClick={() => deleteBlackListIp(item, index)} className="delete">
              remove from black list
            </td>
          )
        }}
        overTableSlots={
          <div className="content_download">
            {filteredData.length > 0 ? (
              <>
                <a
                  title="Download as Excel"
                  onClick={() => {
                    xlsxExport({
                      data: filteredData,
                      headers: colHeaders,
                      fileName: "black-list-ips",
                      dataStructure: "jts"
                    });
                  }}
                >
                  <FontAwesomeIcon icon={faDownload} /> Download as Excel
                </a>
                <a
                  title="Download as CSV"
                  onClick={() => {
                    xlsxExport({
                      data: filteredData,
                      headers: colHeaders,
                      fileName: "black-list-ips",
                      dataStructure: "jts",
                      fileType: "csv"
                    });
                  }}
                >
                  <FontAwesomeIcon icon={faDownload} /> Download as CSV
                </a>
              </>
            ) : (
              <>
                <span disabled>
                  <FontAwesomeIcon icon={faDownload} /> Download as Excel
                </span>
                <span disabled>
                  <FontAwesomeIcon icon={faDownload} /> Download as CSV
                </span>
              </>
            )}
          </div>
        }
      />
    </div>
  ) : (
    <div className="error">No data available</div>
  );
};
